import React from "react";
import {
  FullscreenIconOnlyButton,
  useGraphV2FullscreenActions,
} from "../ChartFullscreenShell";

const btnBase = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "32px",
  height: "32px",
  padding: "0",
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  backgroundColor: "#fff",
  cursor: "pointer",
  transition: "all 0.2s ease",
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
};

/**
 * Modern icon-based legend controls for Select All / Deselect All,
 * plus optional fullscreen (when rendered inside graphViewV2 ChartFullscreenShell).
 */
export default function LegendControls({ onSelectAll, onDeselectAll }) {
  const fs = useGraphV2FullscreenActions();

  return (
    <div
      data-html2canvas-ignore="true"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        marginBottom: "10px",
        width: "100%",
      }}
    >
      {fs?.isFullscreen && fs.graphTitle ? (
        <span
          title={fs.graphTitle}
          style={{
            minWidth: 0,
            flex: "1 1 auto",
            fontSize: "13px",
            fontWeight: 600,
            color: "#0f172a",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            paddingRight: "8px",
          }}
        >
          {fs.graphTitle}
        </span>
      ) : null}
      <div
        style={{
          display: "flex",
          gap: "6px",
          flexShrink: 0,
          marginLeft: fs?.isFullscreen ? 0 : "auto",
        }}
      >
        {/* Select All */}
        <button
          onClick={onSelectAll}
          title="Show all series"
          aria-label="Show all series"
          type="button"
          style={btnBase}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f0f9ff";
            e.currentTarget.style.borderColor = "#0ea5e9";
            e.currentTarget.style.boxShadow = "0 2px 4px rgba(14, 165, 233, 0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#fff";
            e.currentTarget.style.borderColor = "#e5e7eb";
            e.currentTarget.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ color: "#0ea5e9" }}
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </button>

        {/* Deselect All */}
        <button
          onClick={onDeselectAll}
          title="Hide all series"
          aria-label="Hide all series"
          type="button"
          style={btnBase}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#fef2f2";
            e.currentTarget.style.borderColor = "#ef4444";
            e.currentTarget.style.boxShadow = "0 2px 4px rgba(239, 68, 68, 0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#fff";
            e.currentTarget.style.borderColor = "#e5e7eb";
            e.currentTarget.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ color: "#64748b" }}
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        {fs?.toggleFullscreen ? <FullscreenIconOnlyButton /> : null}
      </div>
    </div>
  );
}
